import React, { useEffect, useState } from "react";
import { Alert, Box } from "@curves/ui-base";
import { isEmpty } from "lodash";
import useMemberCyclePurchaseApi from "@apis/useMemberCyclePurchaseApi";
import { CycleEffectOrderCard } from "@icoach/members/components/PendingCycleEffectOrderList";
import { isFunction } from "@util/utils";

const CyclePurchaseDetailOrderFuture = ({ sourceData: sourceDataProps, refresh: refreshProps, dialogRef }) => {
	const { memberID, cycleOrderID } = sourceDataProps || {};
	const { getMemberCycleOrderFutureApi } = useMemberCyclePurchaseApi();
	const [sourceData, setSourceData] = useState([]);

	const doMemberCycleOrderFutureApi = async (memberID, cycleOrderID) => {
		let res = await getMemberCycleOrderFutureApi(memberID, cycleOrderID);
		if (res) {
			setSourceData(res);
			return res;
		}
	};

	const refresh = () => {
		isFunction(refreshProps) && refreshProps();
		doMemberCycleOrderFutureApi(memberID, cycleOrderID);
	};

	useEffect(() => {
		if (memberID && cycleOrderID) {
			doMemberCycleOrderFutureApi(memberID, cycleOrderID);
		}
		// eslint-disable-next-line
	}, [memberID, cycleOrderID]);

	return (
		<React.Fragment>
			{Array.isArray(sourceData) && !isEmpty(sourceData) ? (
				<Box component={"ul"} className="minor-orders">
					{sourceData.map((item, i) => (
						<Box component={"li"} key={i} className="minor-order-item">
							<CycleEffectOrderCard sourceData={item} cycleOrderID={cycleOrderID} refresh={refresh} dialogRef={dialogRef} />
						</Box>
					))}
				</Box>
			) : (
				<Alert className={"mb-4"} color="info" severity="info" variant="filled">
					尚無資料
				</Alert>
			)}
		</React.Fragment>
	);
};

export default CyclePurchaseDetailOrderFuture;
